"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _Icon = require("@quixeltools/quixel-ui-library/dist/components/common/website/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textInput = function textInput() {
  return (0, _glamor.css)({
    display: "inline-block",

    width: "100%"
  });
};

var labelErrorWrap = (0, _glamor.css)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});

var inputWrap = (0, _glamor.css)({
  position: "relative"
});

var preloader = (0, _glamor.css)({
  position: "absolute",
  top: 15,
  right: 14
});

var iconCss = (0, _glamor.css)({
  position: "absolute",
  top: 12,
  right: 12,
  color: _css.pallets.blue_primary
});
var textinput = (0, _glamor.css)(_fonts.subH4, {
  display: "block",
  color: _css.pallets.gray_text,
  textTransform: "uppercase",
  marginBottom: (0, _css.unitRem)(0.25)
});

var inputLabel = function inputLabel(error, icon) {
  return (0, _glamor.css)((0, _fonts.textInputfield)(error, icon), {
    display: "block",
    filter: "none",
    border: "2px solid " + (error ? _css.pallets.red : _css.pallets.darkGray_background),

    color: _css.pallets.white,
    background: _css.pallets.darkGray_background,

    padding: icon ? "0 " + (0, _css.unitRem)(1.8) + " 0 " + (0, _css.unitRem)(0.6) : "0 " + (0, _css.unitRem)(0.6),

    width: "100%",
    height: (0, _css.unitRem)(2),

    transition: "border " + _css.time.fast,

    ":hover": {
      border: "2px solid " + _css.pallets.gray_text
    },

    ":focus": {
      border: "2px solid " + _css.pallets.blue_primary,
      outline: "none"
    },

    "::placeholder": { color: _css.pallets.gray_text, letterSpacing: "-0.5px" },
    "::-webkit-input-placeholder": { color: _css.pallets.gray_text },
    "::-moz-placeholder": { color: _css.pallets.gray_text },
    "::-ms-input-placeholder": { color: _css.pallets.gray_text },

    ":disabled": {
      cursor: "not-allowed"
    }
  });
};

var inputErrorCss = function inputErrorCss(below) {
  return (0, _glamor.css)((0, _fonts.errorCss)(below), (0, _extends3.default)({
    display: "block",
    color: _css.pallets.red
  }, below && {
    marginTop: (0, _css.unitRem)(0.25),
    position: "absolute"
  }, !below && {
    marginBottom: (0, _css.unitRem)(0.25)
  }));
};

var showError = function showError(error, touched) {
  return !!(_ramda2.default.is(Boolean, touched) ? error && touched : error);
};

var TextInput = function TextInput(_ref) {
  var label = _ref.label,
      disabled = _ref.disabled,
      autoCompleteProp = _ref.autoCompleteProp,
      placeholder = _ref.placeholder,
      type = _ref.type,
      error = _ref.error,
      simpleError = _ref.simpleError,
      touched = _ref.touched,
      value = _ref.value,
      inputClassName = _ref.inputClassName,
      className = _ref.className,
      autoFocus = _ref.autoFocus,
      loading = _ref.loading,
      errorBelow = _ref.errorBelow,
      icon = _ref.icon,
      correct = _ref.correct,
      isValidResult = _ref.isValidResult,
      accept = _ref.accept,
      filename = _ref.filename,
      onIconClick = _ref.onIconClick,
      restProps = (0, _objectWithoutProperties3.default)(_ref, ["label", "disabled", "autoCompleteProp", "placeholder", "type", "error", "simpleError", "touched", "value", "inputClassName", "className", "autoFocus", "loading", "errorBelow", "icon", "correct", "isValidResult", "accept", "filename", "onIconClick"]);

  return _react2.default.createElement(
    "div",
    { className: className },
    _react2.default.createElement(
      "label",
      { className: textInput(showError(error, touched)) },
      _react2.default.createElement(
        "div",
        { className: labelErrorWrap },
        label && _react2.default.createElement(
          "span",
          { className: textinput },
          label
        ),
        !errorBelow && !simpleError && showError(error, touched) && _react2.default.createElement(
          "span",
          { className: inputErrorCss(false) },
          error
        )
      ),
      _react2.default.createElement(
        "div",
        { className: inputWrap },
        type === "file" ? _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            {
              className: (0, _glamor.css)(inputLabel(!!showError(error, touched), icon), inputClassName)
            },
            filename ? filename : placeholder
          ),
          _react2.default.createElement("input", (0, _extends3.default)({
            className: (0, _glamor.css)({ opacity: 0 }),
            disabled: disabled,
            type: type,
            autoComplete: autoCompleteProp,
            autoFocus: autoFocus,
            accept: accept,
            placeholder: placeholder
          }, _ramda2.default.omit(["initialValue", "autofill", "onUpdate", "valid", "invalid", "dirty", "pristine", "active", "visited", "autofilled"], restProps)))
        ) : _react2.default.createElement("input", (0, _extends3.default)({
          className: (0, _glamor.css)(inputLabel(!!showError(error, touched), icon), inputClassName),
          disabled: disabled,
          type: type,
          autoComplete: autoCompleteProp,
          value: value || "",
          autoFocus: autoFocus,
          placeholder: placeholder
        }, _ramda2.default.omit(["initialValue", "autofill", "onUpdate", "valid", "invalid", "dirty", "pristine", "active", "visited", "autofilled"], restProps))),
        !(errorBelow && !simpleError && showError(error, touched)) && isValidResult && value.length > 2 && !loading && icon && _react2.default.createElement(
          "div",
          { className: iconCss, onClick: onIconClick },
          _react2.default.createElement(_Icon2.default, {
            color: _css.pallets.blue,
            type: icon,
            width: 24,
            height: 24,
            viewBox: "0 0 50 50"
          })
        ),
        icon && !loading && type === "file" && _react2.default.createElement(
          "div",
          { className: iconCss },
          _react2.default.createElement(_Icon2.default, icon)
        ),
        loading && _react2.default.createElement(_Preloader2.default, { className: preloader })
      ),
      errorBelow && !simpleError && showError(error, touched) && _react2.default.createElement(
        "span",
        { className: inputErrorCss(true) },
        error
      )
    )
  );
};

exports.default = TextInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TextInput/TextInput.jsx
// module id = 2674
// module chunks = 0